var _mask, _g, _path, _path2, _path3, _path4, _path5, _path6, _mask2, _g2, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 32,
    viewBox: "0 0 151 32",
    fill: "none",
    ref: svgRef
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 18,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.21875 8.96387H17.4489V31.1413H0.21875V8.96387Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6779 26.6036H9.49914C11.0006 26.6036 11.8876 25.8189 11.8876 24.2152C11.8876 22.6798 10.9324 21.8951 9.29454 21.8951H5.6779V26.6036ZM5.6779 18.0737H9.15814C10.5569 18.0737 11.5464 17.2888 11.5464 15.7878C11.5464 14.2863 10.6594 13.5016 9.15814 13.5016H5.6779V18.0737ZM9.77215 8.96387C14.0714 8.96387 17.0056 11.3862 17.0056 14.7641C17.0056 17.1185 15.709 18.7902 13.9689 19.6774C16.0502 20.5985 17.4489 22.4068 17.4489 24.8635C17.4489 28.8213 14.4124 31.1413 9.84055 31.1413H0.218628V8.96387H9.77215Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5354 26.6036C38.8084 28.173 38.8084 29.5719 38.5354 31.1413H23.0793V8.96387H38.5354C38.8084 10.5333 38.8084 11.9322 38.5354 13.5016H28.5384V17.6643H37.3752C37.6484 19.2337 37.6484 20.6326 37.3752 22.202H28.5384V26.6036H38.5354Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8266 26.6036C60.0996 28.173 60.0996 29.5719 59.8266 31.1413H44.3707V8.96387H59.8266C60.0996 10.5333 60.0996 11.9322 59.8266 13.5016H49.8296V17.6643H58.6666C58.9396 19.2337 58.9396 20.6326 58.6666 22.202H49.8296V26.6036H59.8266Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6217 31.1414C84.0523 31.4144 82.9264 31.4144 81.3567 31.1414L71.0187 18.142V31.1414C69.4491 31.4144 67.1291 31.4144 65.5594 31.1414V8.96376C67.1291 8.69096 68.2548 8.69096 69.8244 8.96376L80.1624 21.9632V8.96376C81.732 8.69096 84.0523 8.69096 85.6217 8.96376V31.1414Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.64 17.9032C106.913 19.4726 106.913 20.8715 106.64 22.4409H97.8029V31.1415C96.2333 31.4143 93.9132 31.4143 92.3436 31.1415V8.96387H107.8C108.073 10.5333 108.073 11.9322 107.8 13.5016H97.8029V17.9032H106.64Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.344 20.0527C118.344 24.4883 121.209 27.1155 124.553 27.1155C127.897 27.1155 130.763 24.4883 130.763 20.0527C130.763 15.617 127.897 12.9901 124.553 12.9901C121.209 12.9901 118.344 15.617 118.344 20.0527ZM136.324 20.0527C136.324 26.4331 131.582 31.6532 124.553 31.6532C117.525 31.6532 112.782 26.4331 112.782 20.0527C112.782 13.6723 117.525 8.45215 124.553 8.45215C131.582 8.45215 136.324 13.6723 136.324 20.0527Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.167 5.14033V10.0775H145.104C145.306 10.0775 145.506 10.0639 145.702 10.04L140.204 4.54236C140.18 4.73864 140.167 4.93776 140.167 5.14033Z",
    fill: "black"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 0,
    width: 7,
    height: 6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.291 0.202881H150.041V5.95271H144.291V0.202881Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.041 5.1403C150.041 2.41777 147.826 0.202881 145.104 0.202881C144.827 0.202881 144.556 0.227035 144.291 0.271081L149.973 5.95281C150.017 5.68833 150.041 5.41716 150.041 5.1403Z",
    fill: "black"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.154 7.9592L142.285 1.09045C141.757 1.45865 141.305 1.92713 140.955 2.46826L147.776 9.2887C148.317 8.93897 148.785 8.48673 149.154 7.9592Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.29c50d6d.svg";
export { ForwardRef as ReactComponent };